//
// Copyright (c) 2011-2024 by Curalate, Inc.
//
import { INgRedux } from 'ng-redux';

/**
 * We are unable to use Redux or the Angular injector due to the multiple Angular context issue.
 * Every time we open the UIA modal, Angular bootstrap a new context, and the main Redux instance will be unavailable.
 * Also, all Angular stateful services will not work as expected.
 * In order to temporarily fix the problem, we can use a shared instance of Redux from the main Angular context.
 * Our goal is to migrate the entire UIA modal to React to resolve this problem.
 *
 * New modal bootstrapper:
 * app/components/common/universal-image-actions/universal-image-actions-modal.js
 *
 * TODO: PD-261610 - Migrate the UIA modal to React and remove the shared ngReduxInstance.
 */
let ngReduxInstance: INgRedux | undefined = undefined;

export const setNgRedux = (instance: INgRedux) => {
  ngReduxInstance = instance;
};

export const getNgRedux = () => {
  return ngReduxInstance!;
};
